import { object, string, ref, InferType } from "yup";


export const ProfileSchema = object().shape({
    salutation: string().default("").required("salutation is required"),
    firstName: string().default("").required("first name is required"),
    lastName: string().default("").required("last name is required"),
    email: string().default("").email("enter a valid email").required("email is required"),
    phoneNumber: string().default("").required("phone number is required"),
    clientType: string().default("").required("client type is required"),
})

export const IdentificationSchema = object().shape({
    nationality: string().default("").required("nationality is required"),
    dateOfBirth: string().default(""),
    identificationType: string().default("").required("identification type is required"),
    identificationNumber: string().default("").required("identification number is required"),
})

export const BusinessDetailsSchema = object().shape({
    businessName: string().default("").required("business name is required"),
    businessTradingName: string().default(""),
    businessTinNumber: string().default(""),
    businessRegion: string().default("").required("region is required"),
    businessDistrict: string().default("").required("district is required"),
    businessStreet: string().default(""),
    businessLat: string().default(""),
    businessLng: string().default(""),
    businessManager: string().default("").required("manager name is required"),
    businessPhone: string().default("").required("phone number is required"),
    businessEmail: string().default("").email("enter a valid email").required("email is required"),
})

export const ChangePasswordSchema = object().shape({
    otp: string().default("").required("the code sent to your email is required"),
    password: string().default("").min(6, "password must be at least 6 characters").required("password is required"),
    repeatPassword: string().default("")
        .oneOf([ref("password")], "passwords must match")
        .required("repeat password is required"),
})

export type TProfileSchema = InferType<typeof ProfileSchema>;
export type TIdentificationSchema = InferType<typeof IdentificationSchema>;
export type TBusinessDetailsSchema = InferType<typeof BusinessDetailsSchema>;
export type TChangePasswordSchema = InferType<typeof ChangePasswordSchema>;
